module.exports = __webpack_public_path__ + "img/bolsasantiago.8b228067.png";